import React, { useState, useEffect } from "react";

import cube from "services/cube";
import { Form, Loading } from "components";

export function Plans({ onChange, value, isMulti = false, disabled }) {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    cube
      .get("/list/plans")
      .then((response) => setPlans(response.data))
      .catch((error) => console.error(error));
  }, []);

  if (!plans.length) {
    return <Loading />;
  }

  return (
    <Form.Select
      placeholder="Todos"
      isMulti={isMulti}
      value={value}
      disabled={disabled}
      onChange={onChange}
      options={plans.map((plan) => ({
        value: plan.id,
        label: plan.name,
      }))}
    />
  );
}
